import { CreateSupportRequestRequest } from '../api';

interface CreateSupportRequestPayloadParams {
  clientRequestId: string;
  message: string;
  pathname: string;
  shipmentId?: string;
}

export const createSupportRequestPayload = (
  params: CreateSupportRequestPayloadParams
): CreateSupportRequestRequest => {
  const {
    clientRequestId,
    message,
    pathname,
    shipmentId
  } = params;

  return {
    clientRequestId,
    message,
    ...(shipmentId ? { shipmentId } : {}),
    sourceRoute: pathname
  };
};